export default class EditLocationError extends Error {

}